// i18n translations ES/EN for Jelly by Enkor
export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      products: 'Productos',
      about: 'Sobre Jelly',
      distributors: 'Distribuidores',
      contact: 'Contacto',
      registration: 'Registro',
      raffle: 'Sorteo en vivo',
    },
    hero: {
      eyebrow: 'NUEVA COLECCIÓN — JELLY UP MAMACITA!',
      title: 'Tu nueva obsesión desbloqueada',
      subtitle: 'Tu dosis extra de glow al alcance de tu bolsillo. Maquillaje divertido y de alta calidad, respaldado por más de 20 años de Enkor.',
      cta: 'Descubrir colección',
      explore: 'Ver productos',
    },
    home: {
      collectionEyebrow: 'COLECCIÓN JELLY',
      collectionTitle: 'Texturas que se sienten como tú',
      collectionBody: 'Fórmulas ligeras, pigmentos vibrantes y envases coleccionables. Diseñados para vivir, posar y repostear.',
      featuredEyebrow: 'DESTACADOS',
      featuredTitle: 'Los favoritos de las Jelly Girlies',
      featuredCta: 'Ver todo el catálogo',
      socialEyebrow: 'JELLY EN LA RED',
      socialTitle: 'Trending en TikTok & Instagram',
      socialBody: 'Comparte tu look con #JellyGirlies y aparece en nuestro feed.',
      diversityEyebrow: 'PARA TODA PIEL',
      diversityTitle: 'Toda piel, todo tono, toda tú',
      diversityBody: 'Jelly se hace en 6 tonos pensados para piel real — desde la más clara hasta la más profunda. Porque el glow es de todas.',
      followUs: 'Síguenos',
      statsExperience: 'Años de experiencia',
      statsCountries: 'Países',
      statsHappy: 'Clientas felices',
      statsShades: 'Tonos disponibles',
    },
    products: {
      title: 'Catálogo digital',
      subtitle: 'Seis esenciales Jelly, infinitas posibilidades.',
      view: 'Ver detalles',
      back: '← Volver al catálogo',
      key_ingredients: 'Ingredientes clave',
      how_to_use: 'Modo de uso',
      shades: 'Tonos disponibles',
      askWhatsapp: 'Consultar por WhatsApp',
    },
    about: {
      eyebrow: 'SOBRE JELLY',
      title: 'Color, libertad y mucha actitud',
      lead: 'Jelly nace del corazón de Enkor con una misión: que nadie te quite ese glow. Belleza divertida, cercana y honesta para Gen Z y Alpha.',
      p1: 'Somos un universo de placer, juego y bienestar. Mezclamos estética Y2K, foodcore y mucha actitud para crear productos que se sienten ricos, ligeros y cercanos — pensados para la generación que vive en pantalla pero sueña en grande.',
      p2: 'Cada producto pasa por las pruebas de calidad de Enkor antes de llegar a tus manos. Cuidarte también es quererte: Jelly tiene las 3B — Bueno, Bonito, Barato.',
      pillars: 'Nuestros pilares',
      p_quality: 'Bueno',
      p_quality_d: 'Calidad respaldada por +20 años de Enkor. Fórmulas que cumplen.',
      p_fun: 'Bonito',
      p_fun_d: 'Texturas jelly, estética Y2K y empaques que se sienten ricos.',
      p_access: 'Barato',
      p_access_d: 'Tu dosis extra de glow al alcance de tu bolsillo. Sin culpa.',
    },
    distributors: {
      eyebrow: 'B2B / MAYORISTA',
      title: 'Vende Jelly en tu tienda',
      subtitle: 'Únete a la red de distribuidores Jelly by Enkor en LATAM y el mundo. Cuéntanos sobre tu negocio y nuestro equipo te contactará en menos de 48h.',
      formTitle: 'Solicitud de distribución',
      businessName: 'Nombre del negocio',
      contactName: 'Persona de contacto',
      email: 'Correo electrónico',
      phone: 'WhatsApp / Teléfono',
      country: 'País',
      city: 'Ciudad',
      businessType: 'Tipo de negocio',
      businessTypePlaceholder: 'Selecciona una opción',
      bt_boutique: 'Boutique de belleza',
      bt_pharmacy: 'Farmacia / Drugstore',
      bt_online: 'Tienda online',
      bt_chain: 'Cadena retail',
      bt_other: 'Otro',
      monthlyVolume: 'Volumen mensual estimado',
      vol_1: 'Menos de 100 unidades',
      vol_2: '100 – 500 unidades',
      vol_3: '500 – 2,000 unidades',
      vol_4: 'Más de 2,000 unidades',
      message: 'Cuéntanos sobre tu negocio (opcional)',
      submit: 'Enviar solicitud',
      submitting: 'Enviando…',
      success: '¡Solicitud enviada! Te contactaremos pronto.',
      error: 'No pudimos enviar tu solicitud. Intenta de nuevo.',
    },
    contact: {
      eyebrow: 'CONTACTO',
      title: '¿Hablamos?',
      subtitle: 'Estamos aquí para ti — escríbenos por tu canal favorito.',
      whatsapp: 'WhatsApp',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      email: 'Correo',
      writeUs: 'Escríbenos',
      yourName: 'Tu nombre',
      yourEmail: 'Tu correo',
      subject: 'Asunto',
      message: 'Mensaje',
      submit: 'Enviar mensaje',
      submitting: 'Enviando…',
      success: '¡Mensaje enviado!',
      error: 'No pudimos enviar el mensaje.',
    },
    admin: {
      title: 'Panel Jelly',
      subtitle: 'Leads, distribuidores y datos Expobelleza',
      passwordPh: 'Contraseña de administrador',
      login: 'Entrar',
      logout: 'Cerrar sesión',
      empty: 'Aún no hay solicitudes.',
      delete: 'Eliminar',
      confirmDelete: '¿Eliminar esta solicitud?',
      exportCsv: 'Exportar a CSV',
      tabs: {
        registrations: 'Registros Expobelleza',
        distributors: 'Distribuidores B2B',
      },
      status: {
        new: 'Nueva',
        contacted: 'Contactado',
        approved: 'Aprobado',
        rejected: 'Rechazado',
        won: 'Ganador sorteo',
        discarded: 'Descartado',
      },
      stats: {
        total: 'Solicitudes totales',
        new: 'Nuevas',
        approved: 'Aprobadas',
        messages: 'Mensajes contacto',
        registrations: 'Registros Expo',
        wholesale: 'Mayoristas',
        retail: 'Consumidor final',
        raffle: 'En sorteo',
        knewJelly: 'Ya conocían Jelly',
        wouldBuy: 'Compraría la marca',
      },
      breakdown: {
        cities: 'Top ciudades',
        interests: 'Interés principal',
        favorites: 'Producto favorito',
      },
    },
    registration: {
      eyebrow: 'EXPOBELLEZA 2026',
      title: 'Regístrate y participa por kits Jelly',
      subtitle: 'Cuéntanos un poco sobre ti y participa por kits Jelly durante Expobelleza 2026. Tu opinión nos ayuda a llevar Jelly a más rincones del país.',
      raffleBadge: 'SORTEO EN VIVO · EXPOBELLEZA 2026',
      raffleNote: 'Al registrarte, automáticamente participas por kits Jelly durante Expobelleza 2026.',
      sectionContact: 'Tus datos',
      sectionSurvey: 'Encuesta rápida',
      name: 'Nombre completo',
      phone: 'Celular (WhatsApp)',
      email: 'Correo electrónico',
      city: 'Ciudad',
      currentDistributor: '¿Dónde compras tu maquillaje hoy? (opcional)',
      customerType: '¿Eres mayorista o consumidor final?',
      ct_wholesale: 'Mayorista / Negocio',
      ct_retail: 'Consumidor final',
      mainInterest: 'Interés principal',
      mi_makeup: 'Maquillaje',
      mi_skincare: 'Skincare',
      mi_accessories: 'Accesorios',
      knewJelly: '¿Conocías Jelly antes de hoy?',
      yes: 'Sí',
      no: 'No',
      maybe: 'Tal vez',
      favoriteProduct: '¿Cuál producto te gustó más?',
      favoriteProductPh: 'Selecciona un producto',
      wouldBuy: '¿Comprarías la marca?',
      businessCity: '¿En qué ciudad está tu negocio? (opcional)',
      entersRaffle: 'Quiero participar en el sorteo de kits Jelly · Expobelleza 2026',
      submit: '¡Quiero ser parte de Jelly!',
      submitDistributor: 'Quiero ser distribuidor Jelly',
      submitting: 'Enviando…',
      success: '¡Listo! Quedaste registrado y participando por kits Jelly 💕',
      successFollowTitle: 'Síguenos para no perderte el sorteo',
      successFollowBody: 'Anunciamos a las ganadoras en nuestras redes. ¡No te lo pierdas!',
      error: 'No pudimos completar tu registro. Intenta de nuevo.',
      errorDuplicatePhone: 'Este número de celular ya está registrado en el sorteo. Cada persona solo puede participar una vez.',
      errorDuplicateEmail: 'Este correo ya está registrado en el sorteo. Cada persona solo puede participar una vez.',
      placeholder: 'Selecciona una opción',
    },
    footer: {
      tagline: 'Tu nueva obsesión desbloqueada',
      shop: 'Catálogo',
      brand: 'Marca',
      legal: 'Legal',
      rights: 'Todos los derechos reservados.',
      backed: 'Powered by Enkor — +20 años en belleza',
    },
    common: {
      loading: 'Cargando…',
      learnMore: 'Saber más',
    },
  },
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About Jelly',
      distributors: 'Distributors',
      contact: 'Contact',
      registration: 'Register',
      raffle: 'Live raffle',
    },
    hero: {
      eyebrow: 'NEW COLLECTION — JELLY UP MAMACITA!',
      title: 'Your new obsession unlocked',
      subtitle: 'Your extra dose of glow at pocket price. Fun, high-quality makeup backed by 20+ years of Enkor.',
      cta: 'Discover collection',
      explore: 'See products',
    },
    home: {
      collectionEyebrow: 'JELLY COLLECTION',
      collectionTitle: 'Textures that feel like you',
      collectionBody: 'Lightweight formulas, vibrant pigments, collectible packaging. Built to live, pose and repost.',
      featuredEyebrow: 'FEATURED',
      featuredTitle: 'The Jelly gen favourites',
      featuredCta: 'See full catalog',
      socialEyebrow: 'JELLY ONLINE',
      socialTitle: 'Trending on TikTok & Instagram',
      socialBody: 'Tag #JellyGirlies to be featured.',
      diversityEyebrow: 'FOR EVERY SKIN',
      diversityTitle: 'Every skin, every tone, every you',
      diversityBody: 'Jelly comes in 6 shades made for real skin — from the lightest to the deepest. Because the glow belongs to everyone.',
      followUs: 'Follow us',
      statsExperience: 'Years of expertise',
      statsCountries: 'Countries',
      statsHappy: 'Happy customers',
      statsShades: 'Shades available',
    },
    products: {
      title: 'Digital catalog',
      subtitle: 'Six Jelly essentials, endless possibilities.',
      view: 'See details',
      back: '← Back to catalog',
      key_ingredients: 'Key ingredients',
      how_to_use: 'How to use',
      shades: 'Available shades',
      askWhatsapp: 'Ask on WhatsApp',
    },
    about: {
      eyebrow: 'ABOUT JELLY',
      title: 'Colour, freedom and lots of attitude',
      lead: 'Jelly was born from the heart of Enkor with one mission: nobody takes that glow away from you. Fun, close and honest beauty for Gen Z and Alpha.',
      p1: 'A universe of pleasure, play and wellbeing. We blend Y2K aesthetics, foodcore and lots of attitude to make products that feel rich, light and close — designed for the generation that lives on screen but dreams big.',
      p2: 'Every product passes Enkor quality tests before reaching you. Taking care of yourself is also self-love: Jelly has the 3B — Good, Cute, Affordable.',
      pillars: 'Our pillars',
      p_quality: 'Good',
      p_quality_d: 'Quality backed by 20+ years of Enkor. Formulas that deliver.',
      p_fun: 'Cute',
      p_fun_d: 'Jelly textures, Y2K aesthetic and packaging that feels rich.',
      p_access: 'Affordable',
      p_access_d: 'Your extra dose of glow at pocket price. No guilt.',
    },
    distributors: {
      eyebrow: 'B2B / WHOLESALE',
      title: 'Sell Jelly at your store',
      subtitle: 'Join the Jelly by Enkor distributor network across LATAM and beyond. Tell us about your business and we will reach out in less than 48h.',
      formTitle: 'Distribution request',
      businessName: 'Business name',
      contactName: 'Contact person',
      email: 'Email',
      phone: 'WhatsApp / Phone',
      country: 'Country',
      city: 'City',
      businessType: 'Business type',
      businessTypePlaceholder: 'Select an option',
      bt_boutique: 'Beauty boutique',
      bt_pharmacy: 'Pharmacy / Drugstore',
      bt_online: 'Online store',
      bt_chain: 'Retail chain',
      bt_other: 'Other',
      monthlyVolume: 'Estimated monthly volume',
      vol_1: 'Less than 100 units',
      vol_2: '100 – 500 units',
      vol_3: '500 – 2,000 units',
      vol_4: 'More than 2,000 units',
      message: 'Tell us about your business (optional)',
      submit: 'Send request',
      submitting: 'Sending…',
      success: 'Request sent! We will contact you soon.',
      error: 'We could not send your request. Try again.',
    },
    contact: {
      eyebrow: 'CONTACT',
      title: 'Let\'s talk',
      subtitle: 'We\'re here for you — pick your favourite channel.',
      whatsapp: 'WhatsApp',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      email: 'Email',
      writeUs: 'Write to us',
      yourName: 'Your name',
      yourEmail: 'Your email',
      subject: 'Subject',
      message: 'Message',
      submit: 'Send message',
      submitting: 'Sending…',
      success: 'Message sent!',
      error: 'We could not send the message.',
    },
    admin: {
      title: 'Jelly Admin',
      subtitle: 'Leads, distributors and Expobelleza data',
      passwordPh: 'Admin password',
      login: 'Sign in',
      logout: 'Logout',
      empty: 'No requests yet.',
      delete: 'Delete',
      confirmDelete: 'Delete this request?',
      exportCsv: 'Export to CSV',
      tabs: {
        registrations: 'Expobelleza leads',
        distributors: 'B2B distributors',
      },
      status: {
        new: 'New',
        contacted: 'Contacted',
        approved: 'Approved',
        rejected: 'Rejected',
        won: 'Raffle winner',
        discarded: 'Discarded',
      },
      stats: {
        total: 'Total leads',
        new: 'New',
        approved: 'Approved',
        messages: 'Contact messages',
        registrations: 'Expo leads',
        wholesale: 'Wholesale',
        retail: 'Retail',
        raffle: 'In raffle',
        knewJelly: 'Already knew Jelly',
        wouldBuy: 'Would buy',
      },
      breakdown: {
        cities: 'Top cities',
        interests: 'Main interest',
        favorites: 'Favorite product',
      },
    },
    registration: {
      eyebrow: 'EXPOBELLEZA 2026',
      title: 'Register and win a Jelly kit',
      subtitle: 'Tell us a bit about you and enter the raffle for Jelly kits at Expobelleza 2026. Your input helps us bring Jelly to more places.',
      raffleBadge: 'LIVE RAFFLE · EXPOBELLEZA 2026',
      raffleNote: 'By registering, you automatically enter the raffle for Jelly kits during Expobelleza 2026.',
      sectionContact: 'Your info',
      sectionSurvey: 'Quick survey',
      name: 'Full name',
      phone: 'Phone (WhatsApp)',
      email: 'Email',
      city: 'City',
      currentDistributor: 'Where do you buy makeup today? (optional)',
      customerType: 'Are you wholesale or retail?',
      ct_wholesale: 'Wholesale / Business',
      ct_retail: 'Retail / End user',
      mainInterest: 'Main interest',
      mi_makeup: 'Makeup',
      mi_skincare: 'Skincare',
      mi_accessories: 'Accessories',
      knewJelly: 'Did you know Jelly before today?',
      yes: 'Yes',
      no: 'No',
      maybe: 'Maybe',
      favoriteProduct: 'Which product did you like most?',
      favoriteProductPh: 'Pick a product',
      wouldBuy: 'Would you buy the brand?',
      businessCity: 'Where is your business? (optional)',
      entersRaffle: 'I want to enter the Jelly kits raffle · Expobelleza 2026',
      submit: 'I want to be part of Jelly!',
      submitDistributor: 'I want to be a Jelly distributor',
      submitting: 'Sending…',
      success: 'You\'re in! Registered and entered into the raffle 💕',
      successFollowTitle: 'Follow us so you don\'t miss the raffle',
      successFollowBody: 'We announce winners on our socials. Don\'t miss out!',
      error: 'We could not complete your registration. Try again.',
      errorDuplicatePhone: 'This phone number is already registered for the raffle. Each person can only enter once.',
      errorDuplicateEmail: 'This email is already registered for the raffle. Each person can only enter once.',
      placeholder: 'Select an option',
    },
    footer: {
      tagline: 'Beauty for the next generation',
      shop: 'Shop',
      brand: 'Brand',
      legal: 'Legal',
      rights: 'All rights reserved.',
      backed: 'Powered by Enkor — 20+ years in beauty',
    },
    common: {
      loading: 'Loading…',
      learnMore: 'Learn more',
    },
  },
};
